export default __webpack_public_path__ + "static/media/Treating-Customers-Fairly-Nov-2020.10e16a2c.pdf";